import { compact, any } from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { updateOdataOptionsForFinalUrl } from '../util/update-final-url-property-for-filter';

export class AudienceSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);
    const {
      IsAIMCampaignEnabled,
      IsCombinedListAudienceAllowed,
      IsCustomAudienceAllowed,
      IsCustomerHierarchyEnabled,
      IsCustomerListAudienceAllowed,
      IsNewAudienceEnabled,
      IsProductAudienceForSearchEnabled,
      IsRemarketingSimilarAudienceAllowed,
      IsSharedLibraryPhase1Enabled,
    } = this.Permissions;

    const EnableImpressionBasedList = this.Permissions.dynamic && this.Permissions.dynamic.EnableImpressionBasedList;

    if (IsNewAudienceEnabled) {
      const typeField = updatedSchema.properties.Type;
      typeField.enum = compact([
        'Enum.AudienceType\'Remessaging\'',
        (IsAIMCampaignEnabled || IsProductAudienceForSearchEnabled) && 'Enum.AudienceType\'Product\'',
        IsCustomAudienceAllowed && 'Enum.AudienceType\'Custom\'',
        IsRemarketingSimilarAudienceAllowed && 'Enum.AudienceType\'RemarketingSimilar\'',
        IsCustomerListAudienceAllowed && 'Enum.AudienceType\'CustomerList\'',
        IsCombinedListAudienceAllowed && 'Enum.AudienceType\'CombinedList\'',
        EnableImpressionBasedList && 'Enum.AudienceType\'ImpressionBasedRemarketing\'',
      ]);
    }

    const trackingStatusField = updatedSchema.properties.TrackingStatus;
    trackingStatusField.chooseType = 'checkbox';
    trackingStatusField.enum = [
      'Enum.TagTrackingStatus\'Unverified\'',
      'Enum.TagTrackingStatus\'Active\'',
      'Enum.TagTrackingStatus\'Inactive\'',
    ];
    trackingStatusField.enumValueMap = {
      'Enum.TagTrackingStatus\'Unverified\'': 'Unverified',
      'Enum.TagTrackingStatus\'Active\'': 'Active',
      'Enum.TagTrackingStatus\'Inactive\'': 'Inactive',
    };

    const isAudienceTrackingStatusColumnExist = any([
      IsAIMCampaignEnabled,
      IsRemarketingSimilarAudienceAllowed,
      (IsCustomerHierarchyEnabled && IsSharedLibraryPhase1Enabled),
    ]);

    if (!isAudienceTrackingStatusColumnExist) {
      delete updatedSchema.properties.AudienceTrackingStatus;
    }

    if (!(IsCustomerHierarchyEnabled && IsSharedLibraryPhase1Enabled)) {
      delete updatedSchema.properties.OwnerName;
      delete updatedSchema.properties.OwnerNumber;
    }

    delete updatedSchema.properties.Labels;

    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    updateOdataOptionsForFinalUrl(odataOptions);

    return odataOptions;
  }
}
